import React,{useRef} from 'react'
import Herosec from './Components/Herosec'
import Services from './Components/Services'
import Dev from './Components/Dev'
import Mainlanding from '../src/Components/Mainlanding'
import Navbar from './Components/Navbar'
import Footer from './Components/Footer'

const App = () => {
  const contactRef = useRef(null);

  return (
    <div className='overflow-x-hidden'>
      <Navbar scrollToRef={contactRef} />
      <Herosec/>
 <div ref={contactRef}>
        <Mainlanding/>
      </div>
            <Dev/>
            <Footer/>

    </div>
  )
}

export default App